import React from 'react'
import {css} from '@emotion/react'
import styled from '@emotion/styled'

import {Image} from '@daedalus/atlas/src/components/designSystem/Image'
import {ImageProvider} from '@daedalus/core/src/staticContent/types/ImageProvider'

export const IMAGE_WIDTH = 128
export const IMAGE_HEIGHT = 160

interface HotelImageProps {
  imageUrl: string
  imageProvider: ImageProvider
}

const HotelImageContainer = styled('div')(
  css`
    min-height: ${IMAGE_HEIGHT}px;
    min-width: ${IMAGE_WIDTH}px;
    position: relative;
    transition: opacity 500ms ease-in-out;
  `
)

export const HotelImage = ({imageUrl, imageProvider}: HotelImageProps) => (
  <HotelImageContainer>
    <Image
      hasSkeletonLoader
      fullWidth
      height={IMAGE_HEIGHT}
      imageProvider={imageProvider}
      url={imageUrl}
      size="mobileLarge"
    />
  </HotelImageContainer>
)
